import { Box, Stack } from "@mui/material";
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  Text,
} from "@src/appV2/redesign/system/ui-components";
import { round } from "lodash";

import { MapWithAddress } from "../../GeoLocation/MapWithAddress";
import { DotSeparatedText } from "../../Shift/WorkerShift/DotSeparatedText";
import { type PatientData } from "../types";
import { extractZipCode, obscureAddress } from "../utils";

interface PatientLocationListItemProps {
  patient: PatientData;
  workplaceId: string;
  isBooked: boolean;
}

export function PatientLocationListItem(props: PatientLocationListItemProps) {
  const { patient, workplaceId, isBooked } = props;
  const obscuredAddress = obscureAddress(patient.attributes.formattedAddress);
  const zipCode = extractZipCode(patient.attributes.formattedAddress);

  return (
    <ListItem divider>
      <ListItemIcon iconType="map-pin" />
      <ListItemText
        primary={
          <Text semibold variant="h6">
            {isBooked ? obscuredAddress : (zipCode ?? "Location unavailable")}
          </Text>
        }
        secondary={
          <Stack spacing={4} marginTop={2}>
            <DotSeparatedText>
              <Text variant="body2">Patient&apos;s home</Text>
              <Text variant="body2">
                {round(patient.attributes.distanceToWorkerInMiles, 2)} mi from home
              </Text>
            </DotSeparatedText>
            {isBooked && (
              <Box sx={{ height: "13rem", width: "100%" }}>
                <MapWithAddress
                  readonly
                  obscureAddressConfig={{
                    shouldObscureAddress: true,
                    obscuredAddress,
                  }}
                  workplaceId={workplaceId}
                  location={{
                    lat: patient.attributes.latitude,
                    lng: patient.attributes.longitude,
                  }}
                  workplaceFormattedAddress={patient.attributes.formattedAddress}
                />
              </Box>
            )}
          </Stack>
        }
      />
    </ListItem>
  );
}
